export default __webpack_public_path__ + "static/Pick-up-Instructions-Icon@2x-6968cc5308422b3a12a6e07f4ff4fbc9.png";